export enum Steps {
    Custom = "custom",
    PersonalDetails = "personal-details",
    Shipping = "shipping",
    Payment = "payment",
}